import { styled } from "@styles";
import { Text as RootText } from "../styles";
import Link from "@components/common/ui/Link";

export const SuportLink = styled(Link, {
  whiteSpace: "break-all",
  wordWrap: "break-word",
  maxWidth: "100%",
  color: "$blue40",
  fontWeight: "$regular",
  textDecoration: "none",
  overflowWrap: "anywhere",
  "&:not(:disabled):hover": {
    color: "$blue40 !important",
  },
});

export const CopyContainer = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  cursor: "pointer",
  padding: 0,
  gap: "$10px",
});

export const CopyIconWrapper = styled("span", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "24px",
  color: "$neutral60",
  borderRadius: "$sm",
  border: "1px solid $blue40",
  padding: "$4px",
  transition: "opacity 0.5s",
  marginLeft: "$8px",
  cursor: "pointer",
  "&:hover": {
    opacity: "0.7",
  },
  svg: {
    width: "12px",
    height: "12px",
  },
});

export const ProductInfoTable = styled("div", {
  gap: "$16px $32px",
  width: "100%",
  marginTop: "$24px",
});

export const ProductInfoTableItem = styled("div", {
  display: "flex",
  flexWrap: "wrap",

  marginBottom: "$16px",
  minWidth: "48%",
});

export const ProductInfoTitle = styled(RootText, {
  bold: true,
  width: "35%",
});

export const ProductInfoText = styled("div", {
  width: "65%",
  color: "$neutral60",
  fontSize: "$16px",
  lineHeight: "$24px",
  margin: "0",
  display: "flex",
  gap: "$4px",
});
